module.exports = __webpack_public_path__ + "img/icon_streak_flame.37d8b2d0.svg";